module.exports = __webpack_public_path__ + "img/pestanas-4.9f41667d.svg";